const uploadFilesToS3 = () => () => ({});

export default () => ({
  uploadFilesToS3: uploadFilesToS3(),
});
